import { Translate } from '@dreryk/react-common';
import {
   QrCode,
   Separator,
   StandardSpinner,
   StatusBadge,
   StrongText,
   StyledFlex,
   Text,
} from '@dreryk/react-components';

import { translationKeys } from '../../translations';
import { useAiAssistantPhoneConnectionGlobalState } from '../../shared/useAiAssistantPhoneConnectionGlobalState';

import { AiAssistantPhoneConnectedEventListener } from './AiAssistantPhoneConnectedEventListener';
import {
   StyledPhoneConnectBox,
   StyledPhoneConnectQrCode,
} from './AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnect.styled';

const t = translationKeys.mainMenuTileItem.soundSource;

const QR_CODE_SIZE = 150;

type AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectProps = {
   readonly qrCodeUrl: string;
};

export const AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnect = (
   props: AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectProps
): JSX.Element => {
   const { connected } = useAiAssistantPhoneConnectionGlobalState();

   return (
      <StyledFlex direction={'column'} gap={12}>
         <Separator />
         <StrongText testId={'phoneConnectInstruction'}>
            <Translate>{t.phoneConnectInstruction}</Translate>
         </StrongText>
         <StyledPhoneConnectBox>
            <StyledPhoneConnectQrCode alignItems={'center'} justifyContent={'center'}>
               <QrCode testId={'qrCode'} value={props.qrCodeUrl} size={QR_CODE_SIZE} />
            </StyledPhoneConnectQrCode>
            <StyledFlex direction={'column'} gap={4} alignItems={'flex-start'}>
               <StrongText testId={'status'}>
                  <Translate>{t.status}</Translate>
               </StrongText>
               <AiAssistantPhoneConnectedEventListener />
               {connected ? (
                  <>
                     <StatusBadge compact type={'approved'} testId={'statusConnected'}>
                        <Translate>{t.statusConnected}</Translate>
                     </StatusBadge>
                     <Translate>{t.continueOnDevice}</Translate>
                  </>
               ) : (
                  <StyledFlex gap={8} alignItems={'center'}>
                     <Text testId={'statusWaitingForDevice'}>
                        <Translate>{t.statusWaitingForDevice}</Translate>
                     </Text>
                     <StandardSpinner />
                  </StyledFlex>
               )}
            </StyledFlex>
         </StyledPhoneConnectBox>
      </StyledFlex>
   );
};
